// extracted by mini-css-extract-plugin
export default {"container":"About_container__WAkph","spin":"About_spin__OETZM","spinner":"About_spinner__PpB-f"};